import * as React from "react";
import { loadBlockchainData, loadWeb3 } from "../Web3helpers";

import { useNavigate } from "react-router-dom";
export default function SignUp() {
const [username, setUsername] = React.useState("");
const [email, setEmail] = React.useState("");
const [password, setPassword] = React.useState("");


const navigate = useNavigate();

const [accounts, setAccounts] = React.useState(null);
const [auth, setAuth] = React.useState(null);

const loadAccounts = async () => {
	let { auth, accounts } = await loadBlockchainData();

	setAccounts(accounts);
	setAuth(auth);
};

const signUp = async () => {
	if (!username || !email || !password) {
	alert("please fill all details");
	return;
	}
	var mailformat = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
	if (!email.match(mailformat)) {
	alert("please enter valid email address");
	return;
	}
	try {
	await auth.methods
		.createUser(username, email, password)
		.send({ from: accounts });

	localStorage.setItem("username", username);
	localStorage.setItem("email", email);
	localStorage.setItem("password",password);
	navigate("/");
	} catch (e) {
	console.log(e.message);
	}
};
React.useEffect(() => {
	loadWeb3();
}, []);

React.useEffect(() => {
	loadAccounts();
}, []);

return (
	<div style={rootDiv}>
	<img
		src="https://i.postimg.cc/Hnmyyk4N/logo.png"
		style={image}
		alt="geeks"
	/>
	<input
		style={input}
		value={username}
		onChange={(e) => setUsername(e.target.value)}
		placeholder="Username"
		type="text"
	/>
	<input
		style={input}
		value={email}
		onChange={(e) => setEmail(e.target.value)}
		placeholder="Email"
		type="text"
	/>
	<input
		style={input}
		value={password}
		onChange={(e) => setPassword(e.target.value)}
		placeholder="Password"
		type="password"
	/>
	<button style={button} onClick={signUp}>
		{" "}
		Sign Up
	</button>
	</div>
);
}

const rootDiv = {
display: "flex",
flexDirection: "column",
alignItems: "center",

justifyContent: "center",
height: "100vh",
};

const input = {
width: 300,
padding: 10,
margin: 10,
borderRadius: 10,
outline: "none",
border: "2px solid grey",
fontSize: 17,
};

const button = {
width: 325,
padding: 10,
borderRadius: 10,
margin: 10,
cursor: "pointer",
fontSize: 17,
color: "white",
backgroundColor: "#2986cc",
border: "none",
};

const image = {
width: 70,
height: 70,
objectFit: "contain",
borderRadius: 70,
};
